import axiosInstance from "../../api/axios";

export const createUser = async (data: FormData) => {
  try {
    const response = await axiosInstance.post(`/auth/register`, data);
    return {
      success: true,
      data: response.data,
    };
  } catch (error: any) {
    return {
      success: false,
      error:
        error.response?.data?.message ||
        error.message ||
        "Something went wrong",
    };
  }
};

// User List
export const getUsers = async () => {
  try {
    const response = await axiosInstance.get(`/users/list`);
    return {
      success: true,
      data: response.data,
    };
  } catch (error: any) {
    return {
      success: false,
      error:
        error.response?.data?.message ||
        error.message ||
        "Something went wrong",
    };
  }
};

// Users Delete
export const deleteUsers = async (id: number) => {
  try {
    const response = await axiosInstance.delete(`/users/${id}`);
    return {
      success: true,
      data: response.data,
    };
  } catch (error: any) {
    return {
      success: false,
      error:
        error.response?.data?.message ||
        error.message ||
        "Something went wrong",
    };
  }
};